export interface CovariateBucketItem {
  key: string;
}

export interface CovariateBuckets<T extends CovariateBucketItem> {
  nextRequired: T[];
  conditional: T[];
  optional: T[];
}

/**
 * Keep each covariate in exactly one display bucket.
 * A field needed now takes precedence over model-conditional and optional fields.
 */
export const makeCovariateBucketsExclusive = <T extends CovariateBucketItem>(
  buckets: CovariateBuckets<T>,
): CovariateBuckets<T> => {
  const requiredKeys = new Set(buckets.nextRequired.map((item) => item.key));
  const conditional = buckets.conditional.filter((item) => !requiredKeys.has(item.key));
  const occupiedKeys = new Set(requiredKeys);
  conditional.forEach((item) => occupiedKeys.add(item.key));

  return {
    nextRequired: buckets.nextRequired,
    conditional,
    optional: buckets.optional.filter((item) => !occupiedKeys.has(item.key)),
  };
};
